export const defaultArtist = {
  Goods: {
    name: "Goods",
    key: "goods",
    tables: [
      {
        key: "goods",
        name: "Goods",
        allow: "400",
        relation: [
          {
            key: "goods_structure",
            allow: "400"
          },
          {
            key: "goods_subdata_unique",
            allow: "400"
          },
          {
            key: "goods_type",
            allow: "400"
          }
        ]
      },
      {
        key: "goods_title",
        name: "Title",
        allow: "400",
        relation: [
          {
            key: "language",
            allow: "400"
          }
        ]
      },
      {
        key: "goods_artist_relation",
        name: "Artist",
        allow: "400",
        relation: null
      },
      {
        key: "goods_url",
        name: "URL",
        allow: "400",
        relation: null
      },
      {
        key: "goods_company_relation",
        name: "Company",
        allow: "400",
        relation: null
      },
      {
        key: "commodity",
        name: "Commodity",
        allow: "400",
        relation: [
          {
            key: "commodity_url",
            allow: "400"
          }
        ]
      }
    ]
  },
  Metadata: {
    name: "Track",
    key: "metadata",
    tables: [
      {
        key: "metadata",
        name: "Metadata",
        allow: "557",
        relation: [
          {
            key: "metadata_structure",
            allow: "700"
          },
          {
            key: "metadata_subdata_unique",
            allow: "550"
          },
          {
            key: "track_license",
            allow: "500"
          },
          {
            key: "track_license_extra",
            allow: "500"
          },
          {
            key: "type_artist_class",
            allow: "400"
          }
        ]
      },
      {
        key: "metadata_title",
        name: "Title",
        allow: "500",
        relation: [
          {
            key: "language",
            allow: "400"
          }
        ]
      },
      {
        key: "metadata_url",
        name: "URL",
        allow: "500",
        relation: null
      },
      {
        key: "metadata_genre_relation",
        name: "Genre",
        allow: "500",
        relation: null
      },
      {
        key: "metadata_company_relation",
        name: "Company",
        allow: "500",
        relation: null
      },
      {
        key: "track_information",
        name: "Info",
        allow: "500",
        relation: null
      },
      {
        key: "metadata_self_relation",
        name: "Self",
        allow: "500",
        relation: null
      }
    ]
  },
  Artist: {
    name: "Artist",
    key: "artist",
    tables: [
      {
        key: "artist",
        name: "Artist",
        allow: "440",
        relation: null
      },
      {
        key: "artist_title",
        name: "Title",
        allow: "400",
        relation: [
          {
            key: "language",
            allow: "000"
          }
        ]
      },
      {
        key: "artist_url",
        name: "URL",
        allow: "400",
        relation: null
      },
      {
        key: "artist_history",
        name: "History",
        allow: "400",
        relation: null
      },
      {
        key: "artist_company_relation",
        name: "Company",
        allow: "400",
        relation: null
      },
      {
        key: "artist_role_relation",
        name: "Role",
        allow: "500",
        relation: null
      },
      {
        key: "artist_genre_relation",
        name: "Genre",
        allow: "400",
        relation: null
      }
    ]
  },
  MetadataArtistRelation: {
    name: "MetadataArtistRelation",
    key: "metadata_artist_relation",
    tables: [{ key: "metadata_artist_relation", name: "MetadataArtistRelation", allow: "500", extra: "artist_id", relation: null }]
  },
  Role: {
    name: "Role",
    key: "role",
    tables: [
      {
        key: "role",
        name: "Role",
        allow: "550",
        relation: null
      },
      {
        key: "role_title",
        name: "Title",
        allow: "500",
        relation: [
          {
            key: "language",
            allow: "400"
          }
        ]
      }
    ]
  },
  Genre: {
    name: "Genre",
    key: "genre",
    tables: [
      {
        key: "genre",
        name: "Genre",
        allow: "440",
        relation: [
          {
            key: "genre_self_relation",
            allow: "400"
          }
        ]
      },
      {
        key: "genre_title",
        name: "Title",
        allow: "400",
        relation: [
          {
            key: "language",
            allow: "400"
          }
        ]
      },
      {
        key: "genre_url",
        name: "URL",
        allow: "400",
        relation: []
      }
    ]
  },
  Playlist: {
    name: "Playlist",
    key: "playlist",
    tables: [
      {
        key: "playlist",
        name: "Playlist",
        allow: "000",
        relation: [
          {
            key: "playlist_users_relation",
            allow: "000"
          },
          {
            key: "users",
            allow: "400"
          },
          {
            key: "metadata_playlist_relation",
            allow: "000"
          }
        ]
      },
      {
        key: "playlist_title",
        name: "Title",
        allow: "000",
        relation: [
          {
            key: "language",
            allow: "400"
          }
        ]
      },
      {
        key: "playlist_url",
        name: "URL",
        allow: "000",
        relation: []
      }
    ]
  },
  Company: {
    name: "Company",
    key: "company",
    tables: [
      {
        key: "company",
        name: "Company",
        allow: "400",
        relation: [
          {
            key: "company_self_relation",
            allow: "400"
          },
          {
            key: "company_users_relation",
            allow: "400"
          }
        ]
      },
      {
        key: "company_title",
        name: "Title",
        allow: "400",
        relation: null
      }
    ]
  }
};
